import React, { useEffect, useState } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getPatientListAction } from "../../../../store/actions/TokenSystemAction";
import defaultAvatar from "../../../../../src/assets/images/avatar/patient_profile.png";

const TokenSystem = () => {
  const dispatch = useDispatch();
  const [selectedPatient, setSelectedPatient] = useState(null);

  // Get patient list on mount and every 1 minute
  useEffect(() => {
    dispatch(getPatientListAction(false));

    const interval = setInterval(() => {
      dispatch(getPatientListAction(false));
    }, 60000); // refresh every 1 minute

    return () => clearInterval(interval);
  }, [dispatch]);

  // Get from reducer
  const patients = useSelector((state) => state.tokenSystem.patientList || []);

  const currentPatient = patients.find((p) => p.status === "Current");
  const patientQueue = patients.filter((p) => p.status !== "Current");
  const displayPatient = currentPatient;


  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
        justifyContent: "center",
        backgroundColor: "#f8f9fa",
      }}
    >
      {/* Header */}
      <div
        style={{
          width: "100%",
          height: "100px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fff",
          borderBottom: "2px solid #dee2e6",
        }}
      >
        {/*<h1 style={{ margin: 0, fontSize: "2.2rem", fontWeight: 600, color: "#006680" }}>
          OPD No: 101
        </h1>
        <h2 style={{ margin: 0, fontSize: "1.5rem", fontWeight: 400, color: "#34495e" }}>
          Dr. A Sharma
        </h2>*/}
      </div>

      <Row
        style={{
          margin: 0,
          height: "calc(100vh - 100px)",
          padding: "20px",
          display: "flex",
          flexWrap: "nowrap",
        }}
      >
        {/* Left: Current Patient */}
        <Col md={6} style={{ height: "100%", display: "flex", flexDirection: "column" }}>
          <Card style={{ flex: 1 }}>
            <Card.Body
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <h2 style={{ fontSize: "2rem", fontWeight: 600, color: "#34495e", marginBottom: "1rem" }}>
                Current Patient
              </h2>

              <img
                alt="avatar"
                src={displayPatient?.avatar || defaultAvatar}
                className="rounded-circle"
                width="150"
                height="150"
                style={{
                  objectFit: "cover",
                  border: "5px solid #e5e7eb",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                }}
              />

              <div style={{ fontSize: "8rem", fontWeight: "bold", color: "#FA731A", marginTop: "1rem" }}>
                {displayPatient?.token_no?.padStart(2, "0") || "N/A"}
              </div>

              <h3 style={{ fontSize: "4rem", fontWeight: "700", color: "#006680", marginTop: "1rem" }}>
                {displayPatient?.name || "No Patient"}
              </h3>
            </Card.Body>
          </Card>
        </Col>

        {/* Right: Queue */}
        <Col md={6} style={{ height: "100%", display: "flex", flexDirection: "column" }}>
          <Card style={{ flex: 1 }}>
            <Card.Body style={{ overflowY: "auto" }}>
              {patientQueue.length === 0 ? (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "2rem",
                    color: "#888",
                  }}
                >
                  No patient in queue
                </div>
              ) : (
                patientQueue.map((patient, index) => (
                  <div
                    key={patient.queue_id}
                    onClick={() => setSelectedPatient(patient)}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "80px 1fr 60px",
                      alignItems: "center",
                      padding: "10px 20px",
                      marginBottom: "10px",
                      backgroundColor: index % 2 === 0 ? "#e6f7ff" : "#f0fff4",
                      borderRadius: "10px",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      alt="avatar"
                      src={patient.avatar || defaultAvatar}
                      className="rounded-circle"
                      style={{
                        width: "60px",
                        height: "60px",
                        objectFit: "cover",
                        borderRadius: "50%",
                        border: "2px solid #fff",
                        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                      }}
                    />
                    <div>
                      <span
                        style={{
                          display: "block",
                          fontWeight: 600,
                          fontSize: "1.2rem",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {patient.name}
                      </span>
                      <span
                        style={{
                          display: "block",
                          fontWeight: 600,
                          fontSize: "0.9rem",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {patient.time_slot}
                      </span>
                    </div>

                    <span
                      style={{
                        fontWeight: "bold",
                        fontSize: "2rem",
                        color: "#FA731A",
                        textAlign: "center",
                      }}
                    >
                      {patient.token_no?.padStart(2, "0")}
                    </span>
                  </div>
                ))
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default TokenSystem;
